<template>
  <div>
    <!-- 篩選 -->
    <div class="card filter-card">
      <div class="card-body">
        <div class="filter-toggle-icon" @click="toggleFilter">
          <i :class="filterVisible ? 'fa fa-times' : 'fa fa-search'"></i>
        </div>
        <div v-if="filterVisible">
          <div class="row input-row">
            <div class="col-md-3">
              <label for="tid">TID</label>
              <input type="text" id="tid" class="form-control" v-model="filters.tid" />
            </div>
            <div class="col-md-3">
              <label for="serial-number">Serial number</label>
              <input type="text" id="serial-number" class="form-control" v-model="filters.serialNumber" />
            </div>
            <div class="col-md-3">
              <label for="driver-id">Driver ID</label>
              <input type="text" id="driver-id" class="form-control" v-model="filters.driverId" />
            </div>
            <div class="col-1"></div>
            <div class="col-md-3">
              <label for="from-date">From</label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.fromDate" data-language="en" :enable-time-picker="false" placeholder="Select date" />
            </div>
            <div class="col-md-3">
              <label for="to-date">To</label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.toDate" data-language="en" :enable-time-picker="false" placeholder="Select date" />
            </div>
            <div class="col-md-6 mt-4 d-flex justify-content-end">
              <button class="btn btn-reset" @click="resetFilters">Reset</button>
              <button class="btn btn-search" @click="search">Search</button>
            </div>

     
          </div>
        </div>
      </div>
    </div>

    <!-- DataTable -->
    <div class="card mt-4" v-if="paginatedData != ''">
      <div class="card-body">
        <div class="table-responsive signal-table">
          <table class="table table-hover">
            <thead>
              <tr>
                <th 
                  @click="sortTable('created_at')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'created_at'}">
                  <span>Created &nbsp;</span>
                  <i v-if="filters.sort_by === 'created_at' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'created_at' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('start_date')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'start_date'}">
                  <span>Start date &nbsp;</span>
                  <i v-if="filters.sort_by === 'start_date' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'start_date' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('tid')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'tid'}">
                  <span>TID &nbsp;</span>
                  <i v-if="filters.sort_by === 'tid' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'tid' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('mid')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'mid'}">
                  <span>MID &nbsp;</span>
                  <i v-if="filters.sort_by === 'mid' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'mid' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>  
                <th 
                  @click="sortTable('serial_number')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'serial_number'}">
                  <span>Serial number &nbsp;</span>
                  <i v-if="filters.sort_by === 'serial_number' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'serial_number' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>   
                <th scope="col" class="col-assignment">Assignment</th>
                <th scope="col" class="col-assigned-to">Assigned to</th>
                <th scope="col" class="col-enabled">Enabled</th>
                <th scope="col" class="col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paginatedData" :key="index">
                <td>{{ item.created_at }}</td>
                <td>{{ item.start_date }}</td>
                <td>{{ item.tid }}</td>
                <td>{{ item.mid }}</td>
                <td>{{ item.serial_number }}</td>
                <td>
                  <span>Driver</span>
                </td>
                <td>{{ item.driver?.first_name }}&nbsp;{{ item.driver?.middle_name }}&nbsp;{{ item.driver?.last_name }}</td>
                <td>
                  <i :class="item.enabled ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                </td>
                <td>
                  <EditTerminal :terminalId="item.id" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分頁 -->
        <div class="pagination-wrapper">
          <div class="pagination-container">
            <button @click="changePage(1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
            <span>
              Page
                            <input type="number" style="width: 60px;" v-model.number="currentPageInput" @change="changePage(currentPageInput)" />

              of {{ totalPages }}
            </span>
            <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(totalPages)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
          </div>
          <div class="total-count">
            Displaying terminals {{ (currentPage - 1) * itemsPerPage + 1 }} – {{ Math.min(currentPage * itemsPerPage, totalEntries) }} of {{ totalEntries }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-results">No results found.</div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useTerminalsStore } from '@/store/admin/terminal';
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import EditTerminal from './editTerminal.vue';

const terminalStore = useTerminalsStore();

const currentPage = ref(terminalStore.currentPage);
const itemsPerPage = ref(terminalStore.itemsPerPage);
const currentPageInput = ref(currentPage.value);

const filterVisible = ref(false); // 控制查詢器是否顯示，預設為收起

const filters = ref({
  tid: '',
  serialNumber: '',
  driverId: '',
  subgroup: '',
  fromDate: '',
  toDate: '',
  sort_by:'created_at',
  order:'desc',
});

// 表格排序處理邏輯
const sortTable = (field) => {
  if (filters.value.sort_by == field) {
    filters.value.order = filters.value.order === 'asc' ? 'desc' : 'asc';
  } else {
    filters.value.sort_by = field;
    filters.value.order = 'desc';
  }
  terminalStore.fetchTerminals(currentPage.value, itemsPerPage.value, filters.value);
};

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const fetchTerminals = async () => {
  await terminalStore.fetchTerminals(currentPage.value, itemsPerPage.value, filters.value);
};

const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};

const resetFilters = () => {
  filters.value = {
    tid: '',
    serialNumber: '',
    driverId: '',
    fromDate: '',
    toDate: '',
    sort_by:'created_at',
    order:'desc',
  };
  currentPage.value = 1; // 重置時也重置到第一页
  fetchTerminals();
};

const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};


const search = () => {
  // 格式化日期
  filters.value.fromDate = formatDate(filters.value.fromDate);
  filters.value.toDate = formatDate(filters.value.toDate);
  currentPage.value = 1; // 搜索时重置到第一页
  fetchTerminals();
};

const paginatedData = computed(() => {
  return terminalStore.paginatedData;
});

const totalPages = computed(() => {
  return terminalStore.totalPages;
});

const totalEntries = computed(() => {
  return terminalStore.totalEntries;
});

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    currentPageInput.value = page;
    fetchTerminals(); // 切換頁碼時重新加載數據
  }
};

onMounted(() => {
  fetchTerminals(); // 加載時獲取數據
  changePage(1);
});
</script>
  
  <style scoped>
  .card {
    margin: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .card-body {
    padding: 20px;
    position: relative;
  }

  .no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }
  
  .table-responsive {
    margin-top: 20px;
  }
  
  .table-hover tbody tr:hover {
    background-color: #f1f1f1;
  }
  
  
  .pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
  }
  
  .pagination-container {
    display: flex;
    align-items: center;
  }
  
  .pagination-container button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 16px;
    color: #8476f4;
  }
  
  .pagination-container span {
    margin: 0 10px;
  }
  
  .pagination-container input {
    width: 50px;
    text-align: center;
  }
  
  .total-count {
    font-size: 16px;
    color: #666;
  }

  .table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

/* 排序箭頭樣式 */
.sort-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

/* 排序欄位下的綠色下劃線 */
.table th.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #00c962;
  position: absolute;
  bottom: 0;
  left: 0;
}
  
  .btn-reset {
    /* BTN_B */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Green */
    border: 2px solid #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

  }
  .btn-green {
    margin-top: 20px;
    background-color: #00c962;
    height: 40px;
  }

  .btn-search {
    /* BTN_A_V2 */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Green */
    background: #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;

  }

  .btn-reset:hover {
    background: white;
    border: 2px solid #00b452;
  }
  .btn-search:hover {
    background: #00b452;
    border: 2px solid #00b452;
  }
  
  .filter-toggle-icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 24px;
    color: #666;
    cursor: pointer;
  }
  
  .filter-header {
    display: flex;
    justify-content: flex-end;
  }

  .signal-table.table-responsive .table tbody tr td:nth-child(n+2) {
    min-width: 100px !important;
  }

  @media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
  </style>